import React from "react";
import { CiSearch } from "react-icons/ci";

function SearchBar({
  placeholder = "Search…",
  value,
  onChange,
  className = "",
  inputClassName = "",
}) {
  return (
    <div className={`relative ${className}`}>
      <label className="sr-only">Search</label>
      <div className="absolute inset-y-0 left-0 flex items-center pl-3.5 pointer-events-none">
        <CiSearch className="text-xl text-[var(--text-muted)]" />
      </div>
      <input
        type="search"
        className={`
          block w-full py-2.5 pl-10 pr-4 text-sm rounded-xl
          bg-[var(--surface)] text-[var(--text)] placeholder-[var(--text-muted)]
          border border-[var(--border)]
          hover:border-[var(--border-hover)]
          focus:ring-2 focus:ring-blue-500/25 focus:border-blue-500
          transition-all duration-200
          ${inputClassName}
        `}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

export default SearchBar;
